import { useState } from "preact/hooks";
import type { AlbumCopy } from "./content.js";
import { PHOTOS, shelves, shortName } from "./photos.js";

const SHELVES = shelves(PHOTOS);
const NEWEST = [...PHOTOS].reverse();

export interface AlbumProps {
  readonly copy: AlbumCopy;
  readonly event: string;
}

export function Album({ copy, event }: AlbumProps) {
  const [hour, setHour] = useState<number | null>(null);
  const photos =
    hour === null
      ? NEWEST
      : [...(SHELVES.find((shelf) => shelf.hour === hour)?.photos ?? [])].reverse();
  const options: readonly (readonly [number | null, string, number])[] = [
    [null, copy.all, PHOTOS.length],
    ...SHELVES.map((shelf) => [shelf.hour, `${shelf.hour}h`, shelf.photos.length] as const),
  ];
  return (
    <section class="section album" id="album">
      <div class="wrap album-layout">
        <div class="album-intro">
          <p class="micro">{copy.label}</p>
          <h2 class="section-title serif">{copy.title}</h2>
          <p class="split-body">{copy.body}</p>
        </div>
        <div class="album-card">
          <div class="album-top">
            <div>
              <strong>{event}</strong>
              <span data-testid="album-count">
                {photos.length} {copy.photos}
              </span>
            </div>
            <span class="album-badge">{copy.original}</span>
          </div>
          <div class="album-hours">
            {options.map(([value, label, size]) => (
              <button
                key={label}
                type="button"
                class={hour === value ? "chip is-selected" : "chip"}
                aria-pressed={hour === value}
                onClick={() => setHour(value)}
              >
                {label} <span class="album-size">{size}</span>
              </button>
            ))}
          </div>
          <div class="album-photos" key={String(hour)}>
            {photos.map((photo, index) => (
              <figure key={photo.id} class="album-tile" style={{ "--i": index }}>
                <img src={photo.small} alt="" width={560} height={700} loading="lazy" />
                <figcaption>{shortName(photo.author)}</figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
